var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-label-value"},[_c('span',{staticClass:"ps-label-value__label"},[_vm._v(_vm._s(_vm.label || '')+" :")]),_c('span',{staticClass:"ps-label-value__value"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }